export var PLUGIN_NAME = '@amplitude/plugin-network-capture-browser';
export var AMPLITUDE_NETWORK_REQUEST_EVENT = '[Amplitude] Network Request';
// TODO: when @experimental is removed from responseHeaders and requestHeaders,
// remove this constant or set it to false
export var IS_HEADER_CAPTURE_EXPERIMENTAL = true;
